import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "player-table",
  class: "center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { class: "icon" }, "icon"),
  /*#__PURE__*/_createElementVNode("th", { class: "minecraft" }, "minecraft"),
  /*#__PURE__*/_createElementVNode("th", { class: "discord" }, "discord"),
  /*#__PURE__*/_createElementVNode("th", { class: "created_at" }, "created_at"),
  /*#__PURE__*/_createElementVNode("th", { class: "cached_at" }, "cached_at"),
  /*#__PURE__*/_createElementVNode("th", { class: "action" }, "actions")
], -1)
const _hoisted_3 = { class: "icon" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "minecraft" }
const _hoisted_7 = { class: "discord" }
const _hoisted_8 = { class: "action" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-circle-info" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sync" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]

import {DataModel} from "@/models/data.model";
import DateFormat from "@/components/DateFormat.vue";
import {CacheService} from "@/services/cache.service";
import {useRouter} from "vue-router";

export interface TableProps {
  players: DataModel[],
  loadData: Function
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PlayerTable',
  props: {
    players: {},
    loadData: { type: Function }
  },
  setup(__props: any) {

const {players, loadData} = __props;


const router = useRouter();

function details(uuid: string) {
  router.push({
    path: '/details/' + uuid
  })
}

function update(uuid: any) {
  CacheService.updatePlayer(uuid)
      .then(rsp => loadData())
}

return (_ctx: any,_cache: any) => {
  return (_ctx.players.length > 0)
    ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
        _hoisted_2,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.players, (d) => {
          return (_openBlock(), _createElementBlock("tr", null, [
            _createElementVNode("td", _hoisted_3, [
              _createElementVNode("img", {
                src: d.avatar,
                class: "avatar"
              }, null, 8, _hoisted_4),
              _createElementVNode("img", {
                src: `https://visage.surgeplay.com/face/32/${d.uuid}`,
                class: "avatar"
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("td", _hoisted_6, _toDisplayString(d.name), 1),
            _createElementVNode("td", _hoisted_7, _toDisplayString(d.nickname), 1),
            _createVNode(DateFormat, {
              date: d.createdAt,
              class: "created_at"
            }, null, 8, ["date"]),
            _createVNode(DateFormat, {
              date: d.cachedAt,
              class: "cached_at"
            }, null, 8, ["date"]),
            _createElementVNode("td", _hoisted_8, [
              _createElementVNode("button", {
                type: "button",
                class: "details",
                onClick: (e) => details(d.uuid),
                title: "details"
              }, _hoisted_11, 8, _hoisted_9),
              _createElementVNode("button", {
                type: "button",
                class: "update",
                onClick: (e) => update(d.uuid),
                title: "updated"
              }, _hoisted_14, 8, _hoisted_12)
            ])
          ]))
        }), 256))
      ]))
    : _createCommentVNode("", true)
}
}

})